import * as Types from "../constants/Types";

// General Auto Translate Actions
export const autoTranslateRequest = (params) => ({
  type: Types.AUTO_TRANSLATE_REQUEST,
  params,
});
export const autoTranslateSuccess = (result) => ({
  type: Types.AUTO_TRANSLATE_SUCCESS,
  result,
});
export const autoTranslateFailure = (error) => ({
  type: Types.AUTO_TRANSLATE_FAILURE,
  error,
});
export const autoTranslateReset = () => ({ type: Types.AUTO_TRANSLATE_RESET });

// Campaign Auto Translate Actions
export const campaignAutoTranslateRequest = (params) => ({
  type: Types.CAMPAIGN_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const campaignAutoTranslateSuccess = (result) => ({
  type: Types.CAMPAIGN_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const campaignAutoTranslateFailure = (error) => ({
  type: Types.CAMPAIGN_AUTO_TRANSLATE_FAILURE,
  error,
});

// Hotel Auto Translate Actions
export const hotelAutoTranslateRequest = (params) => ({
  type: Types.HOTEL_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const hotelAutoTranslateSuccess = (result) => ({
  type: Types.HOTEL_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const hotelAutoTranslateFailure = (error) => ({
  type: Types.HOTEL_AUTO_TRANSLATE_FAILURE,
  error,
});

// Hotel Auto Translate Actions
export const roomTypeAutoTranslateRequest = (params) => ({
  type: Types.ROOM_TYPE_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const roomTypeAutoTranslateSuccess = (result) => ({
  type: Types.ROOM_TYPE_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const roomTypeAutoTranslateFailure = (error) => ({
  type: Types.ROOM_TYPE_AUTO_TRANSLATE_FAILURE,
  error,
});

// Tour Auto Translate Actions
export const tourAutoTranslateRequest = (params) => ({
  type: Types.TOUR_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const tourAutoTranslateSuccess = (result) => ({
  type: Types.TOUR_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const tourAutoTranslateFailure = (error) => ({
  type: Types.TOUR_AUTO_TRANSLATE_FAILURE,
  error,
});

// Tour Ticket Auto Translate Actions
export const tourTicketAutoTranslateRequest = (params) => ({
  type: Types.TOUR_TICKET_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const tourTicketAutoTranslateSuccess = (result) => ({
  type: Types.TOUR_TICKET_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const tourTicketAutoTranslateFailure = (error) => ({
  type: Types.TOUR_TICKET_AUTO_TRANSLATE_FAILURE,
  error,
});

// Supplier Auto Translate Actions
export const supplierAutoTranslateRequest = (params) => ({
  type: Types.SUPPLIER_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const supplierAutoTranslateSuccess = (result) => ({
  type: Types.SUPPLIER_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const supplierAutoTranslateFailure = (error) => ({
  type: Types.SUPPLIER_AUTO_TRANSLATE_FAILURE,
  error,
});

// Menu Auto Translate Actions
export const menuAutoTranslateRequest = (params) => ({
  type: Types.MENU_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const menuAutoTranslateSuccess = (result) => ({
  type: Types.MENU_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const menuAutoTranslateFailure = (error) => ({
  type: Types.MENU_AUTO_TRANSLATE_FAILURE,
  error,
});

// Tag Group Detail Auto Translate Actions
export const tagGroupDetailAutoTranslateRequest = (params) => ({
  type: Types.TAG_GROUP_DETAIL_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const tagGroupDetailAutoTranslateSuccess = (result) => ({
  type: Types.TAG_GROUP_DETAIL_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const tagGroupDetailAutoTranslateFailure = (error) => ({
  type: Types.TAG_GROUP_DETAIL_AUTO_TRANSLATE_FAILURE,
  error,
});

// VinWonder Tag Group Auto Translate Actions
export const vinWonderTagGroupAutoTranslateRequest = (params) => ({
  type: Types.VINWONDER_TAG_GROUP_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const vinWonderTagGroupAutoTranslateSuccess = (result) => ({
  type: Types.VINWONDER_TAG_GROUP_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const vinWonderTagGroupAutoTranslateFailure = (error) => ({
  type: Types.VINWONDER_TAG_GROUP_AUTO_TRANSLATE_FAILURE,
  error,
});

// Rate Auto Translate Actions
export const rateAutoTranslateRequest = (params) => ({
  type: Types.RATE_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const rateAutoTranslateSuccess = (result) => ({
  type: Types.RATE_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const rateAutoTranslateFailure = (error) => ({
  type: Types.RATE_AUTO_TRANSLATE_FAILURE,
  error,
});

// Rate Plan Auto Translate Actions
export const ratePlanAutoTranslateRequest = (params) => ({
  type: Types.RATE_PLAN_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const ratePlanAutoTranslateSuccess = (result) => ({
  type: Types.RATE_PLAN_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const ratePlanAutoTranslateFailure = (error) => ({
  type: Types.RATE_PLAN_AUTO_TRANSLATE_FAILURE,
  error,
});

// Bookable Package Rate Auto Translate Actions
export const bookablePackageRateAutoTranslateRequest = (params) => ({
  type: Types.BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_REQUEST,
  ...params,
});
export const bookablePackageRateAutoTranslateSuccess = (result) => ({
  type: Types.BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_SUCCESS,
  result,
});
export const bookablePackageRateAutoTranslateFailure = (error) => ({
  type: Types.BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_FAILURE,
  error,
});
